import { useEffect, useRef, useState } from "react";
import TimeFrameSelect from "./TimeFrameSelect";
import type { Chart } from "chart.js";
import { MS_IN_DAY } from "./chartutils";
import { createChart, createChartData, updateChart } from "./chartfuncs";

const TIME_FRAME_BUTTONS: { name: string; timeSub: number; showIf: (minTime: number) => boolean }[] = [
    { name: "All Data", timeSub: 9999 * MS_IN_DAY, showIf: () => true },
    { name: "24 Hours", timeSub: MS_IN_DAY, showIf: () => true },
    { name: "7 Days", timeSub: 7 * MS_IN_DAY, showIf: (minTime) => Date.now() - minTime > MS_IN_DAY },
    { name: "14 Days", timeSub: 14 * MS_IN_DAY, showIf: (minTime) => Date.now() - minTime > 7 * MS_IN_DAY },
];
const DEFAULT_TIME_FRAME = 2;

function getBtnMinTime(selected: number) {
    const btnDef = TIME_FRAME_BUTTONS[selected];
    if (!btnDef) return 0;
    return Date.now() - btnDef.timeSub;
}

const HistoryChart = ({ data }: { data: ApiAuctionItemData[] }): JSX.Element => {
    if (data.length === 0) return <>No Data!</>;
    const dataMinTime = data[0]!.timestamp;
    const chartCanvas = useRef<HTMLCanvasElement>(null);
    const [timeFrameSelected, setTimeFrameSelected] = useState<number>(DEFAULT_TIME_FRAME);
    const [chart, setChart] = useState<Chart>();

    // TODO: How to fix this properly? Double render causes chart to try to use the same canvas twice.
    let chartLoadingHackfix = false;

    useEffect(() => {
        if (chartLoadingHackfix) return;
        if (!chart && chartCanvas.current) {
            chartLoadingHackfix = true;
            setChart(createChart(createChartData(data, getBtnMinTime(timeFrameSelected)), chartCanvas.current));
        }
    }, [chartCanvas]);

    useEffect(() => {
        if (chart) updateChart(chart, createChartData(data, getBtnMinTime(timeFrameSelected)));
    }, [timeFrameSelected, data]);

    const tfsb: { name: string; value: number }[] = [];
    for (const [i, btnDef] of TIME_FRAME_BUTTONS.entries()) {
        if (btnDef.showIf(dataMinTime)) tfsb.push({ name: btnDef.name, value: i });
    }

    return (
        <div>
            <TimeFrameSelect buttons={tfsb} selected={timeFrameSelected} onBtnClick={(idx) => setTimeFrameSelected(idx)} />
            <canvas ref={chartCanvas}></canvas>
        </div>
    );
};

export default HistoryChart;
